var map = {
	"./dv_msg_de.json": 1975,
	"./dv_msg_en.json": 1976,
	"./dv_msg_es.json": 1977,
	"./dv_msg_fr.json": 1978,
	"./dv_msg_ja.json": 1979,
	"./dv_msg_pt.json": 1980,
	"./dv_msg_zh.json": 1981
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1974;